import { cva } from 'class-variance-authority';

export const tooltipStyles = cva(
  ['whitespace-pre-line', 'rounded-md', 'border', 'px-[12px]', 'py-[6px]', 'text-body-small', 'shadow-sm'],
  {
    variants: {
      color: {
        default: ['border-grey-200', 'bg-white', 'text-black'],
        error: ['border-red-500', 'bg-red-50', 'text-red-700'],
      },
    },
    defaultVariants: {
      color: 'default',
    },
  }
);